import { SidebarAndModalContext } from '@/context/sidebarAndModal';
import { Chip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ReactNode, useContext } from 'react';
import { ListItemButtonText, ListItemIcon, StyledListItemButton } from './styles';
import { Text } from '@/components/atoms/text';
import { useTheme } from '@mui/material/styles';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

type SidebarItemProps = {
  dataTestId?: string;
  icon?: ReactNode;
  text: string;
  path?: string;
  onClick?: () => void;
  disabled?: boolean;
  tag?: string;
};

export const SidebarItem = ({
  dataTestId,
  icon,
  text,
  path,
  onClick,
  disabled,
  tag,
}: SidebarItemProps) => {
  const theme = useTheme();
  const location = useLocation();

  const { handleDrawerClose } = useContext(SidebarAndModalContext);

  const isSelected = path ? location.pathname === path : false;

  return (
    <StyledListItemButton
      disabled={disabled}
      data-testid={dataTestId}
      selected={isSelected}
      onClick={() => {
        onClick?.();
        handleDrawerClose();
      }}
    >
      <ListItemIcon>{icon}</ListItemIcon>

      <ListItemButtonText isSelected={isSelected}>
        <Text
          variant="subtitle2"
          color={isSelected ? theme.palette.primary.dark : theme.palette.text.primary}
        >
          <SafeMarkdown text={text} isMenu />
        </Text>

        {tag && <Chip label={tag} variant="outlined" size="small" />}
      </ListItemButtonText>
    </StyledListItemButton>
  );
};
